export default {
    fetchingRegions: false,
    regions: undefined,
    houseTypes: undefined,
    properties: [
        {
            name: "Kids allowed",
            value: false,
            icon: "fas fa-child",
            key: "childrenAllowed"
        },
        {
            name: "Dogs Allowed",
            value: false,
            icon: "fas fa-paw",
            key: "dogsAllowed"
        },
        {
            name: "Swimmingpool/Lake",
            value: false,
            icon: "fas fa-swimmer",
            key: "swimmingPool"
        },
        // {
        //     name: "Short Stay",
        //     value: false,
        //     key: "shortStayAllowed"
        // },
        {
            name: "Internet/WLAN",
            value: false,
            icon: "fas fa-wifi",
            key: "internet"
        },
        {
            name: "Winter accessible",
            value: false,
            icon: "fas fa-snowflake",
            key: "winterAccessible"
        },
        {
            name: "Wheelchair Accessible",
            value: false,
            icon: "fas fa-wheelchair",
            key: "wheelchairAccessible"
        },
        {
            name: "Grill vorhanden",
            value: false,
            icon: "fas fa-fire-alt",
            key: "grill"
        }
    ],


    query: {},
    defaultQuery: {
        numberOfKids: 0,
        numberOfAdults: 0,
        specialOffer: false,
        tags: [],
        selectedDates: {
            start: undefined,
            end: undefined
        },
    },



    
    locale: undefined,
    offer: undefined,


    currentListing: undefined,
    
    // This is used to pass on the current confirmation to the success/failure view
    bookingRequestConfirmation: undefined,
    // TODO: Remove this
    lowestPrice: undefined

    

}